import React,{useState} from 'react'
import Sidemenu from '../../components/sidemenu';
import Header from '../../components/header';
import Footer from '../../components/footer';
import QuestionDetails from '../../components/questionDetails';
import * as Styled from './styled';
import styled from 'styled-components';
import { functionService } from '../../lib/functions';
import { useNavigate } from "react-router-dom";

const Wrapper=styled.input`
color:black;
width:35vw;
margin: 30px;
padding:4px;
`
const DivWrapper=styled.div`
display:flex;
flex-direction:row;
align-items:flex-start;
justify-content:space-around;
height:15%;

position:relative;
`

const StyledButton=styled.button`
width:144px;
height:50px;
border-radius:8px;
background-color:#1B49EA;
color:white;
align-self:flex-end;
margin:20px 30px 0 0;
`

const StyledTitle=styled.p`
color :black;
font-size:16px;
font-weight:700;
position:absolute;
top:-30px;
left:30px;

`
const ModalLinkedin =() => {
    const [title,setJobTitle]=useState('')
    const [assessmentId,setAssesmentId]=useState('')
    const [linkedinToken,setLinkedinToken]=useState('')
    const [jobId,setJobId]=useState(null)   
    let navigate = useNavigate();
    const addJobs=async()=>{
        try {
          const data=await functionService.post('easyapply/add',{jobId,li_at:linkedinToken,assessmentId,title})
          if(data.response.status===200){
              navigate(`/easyapply/get-all`, { replace: true });
            setAssesmentId('')
            setJobId(null)
            setLinkedinToken('')
            setJobTitle('')
          }
        } catch (error) {
        }   
    }

  return (
    <Styled.MainDiv>
      
    <QuestionDetails  />
    <Sidemenu  />
    <Styled.ColumnDiv>
      <Header />

      <Styled.ContentWrapDiv>
        <Styled.ContentDiv>
          <Styled.HeaderWrapDiv>
            <div>New Linkedin Jobs</div>
          
          </Styled.HeaderWrapDiv>

          <Styled.CardDiv>
     <div style={{display:'flex',height:'80vh',flexDirection:'column',justifyContent:'start',alignItems:'start',marginTop:'20px'}}>
<DivWrapper>
   
    <StyledTitle>Job Title <span style={{color:'red'}}>*</span></StyledTitle>
    <Wrapper placeholder="Enter job title here" type='text' value={title} onChange={(e)=>setJobTitle(e.target.value)}/>

 <p style={{position:'absolute',top:'-30px',right:'410px',fontSize:'16px',fontWeight:700}}>Assessment ID <span style={{color:'red'}}>*</span></p>
    <Wrapper placeholder="Enter assessment id here" type='text' value={assessmentId} onChange={(e)=>setAssesmentId(e.target.value)}/>
</DivWrapper>
<DivWrapper > 
<p style={{position:'absolute',top:'-30px',right:'480px',fontSize:'16px',fontWeight:700}}> job ID <span style={{color:'red'}}>*</span> </p> 
      <Wrapper placeholder="Enter linkedin token here" type='text'  value={linkedinToken} onChange={(e)=> setLinkedinToken(e.target.value)} />
      <p style={{position:'absolute',top:'-30px',left:'30px',fontSize:'16px',fontWeight:700}}>Linkedin Token <span style={{color:'red'}}>*</span> </p> 
    <Wrapper placeholder="Enter job id here" type='text' value={jobId} onChange={(e)=> setJobId(e.target.value) }/>
  
    </DivWrapper>
    <StyledButton onClick={()=>addJobs()}  >
    Add New
</StyledButton>
        </div>  
          </Styled.CardDiv>
        </Styled.ContentDiv>

        <Footer />
      </Styled.ContentWrapDiv>

    </Styled.ColumnDiv>
  </Styled.MainDiv>
  )

            }
export default ModalLinkedin
